// Presentational list/tabs block for the dashboard page.
import { SectionTabs } from '@/components/ui/SharedComponents';
import CompletedPanels from '@/features/dashboard/components/CompletedPanels';
import WaitingList from '@/features/dashboard/components/WaitingList';
import {
  TAB_COMPLETED,
  TAB_WAITING,
} from '@/features/dashboard/utils/dashboardPageUtils';

export function DashboardListSection({
  dashTabs,
  dashTab,
  onDashTabChange,
  activeTabId,
  delegatedTasksByPerson,
  completedDays,
  openDay,
  setOpenDay,
  projectFilter,
}) {
  return (
    <>
      <SectionTabs tabs={dashTabs} value={dashTab} onChange={onDashTabChange} />
      {activeTabId === TAB_WAITING ? (
        <WaitingList delegatedTasksByPerson={delegatedTasksByPerson} />
      ) : null}
      {activeTabId === TAB_COMPLETED ? (
        <CompletedPanels
          completedDays={completedDays}
          openDay={openDay}
          setOpenDay={setOpenDay}
          projectFilter={projectFilter}
        />
      ) : null}
    </>
  );
}
